/**
 * URL constants. Use this to have a correct overview of all the hardcoded links
 */
export default {
  HELPDESK_FINALIZE_ORDER:
            "https://anybill.freshdesk.com/support/solutions/articles/80001036392-abschluss-der-bestellung",
  // NOTE: password reset is no longer handled via the Microsoft-hosted B2C page (RESET_PASSWORD_AD
  // has been removed). See /login/forgot-password and /login/reset-password for the in-house flow.

  // -- Nav drawer links  --

  DRAWER_POS_CUSTOMER_SUPPORT_LINK:
            "https://anybill.freshdesk.com/support/solutions/80000459085",
  DRAWER_VENDOR_CUSTOMER_SUPPORT_LINK_DE:
            "https://anybill.freshdesk.com/support/solutions/80000459088",
  DRAWER_VENDOR_CUSTOMER_SUPPORT_LINK_EN:
            "https://anybill.freshdesk.com/support/solutions/folders/80000705115",

  // -- Documents Page --
  DOCUMENTS_PERFORMANCE_DRS_BASIC_EN:
            "https://www.anybill.de/de/legal-documents/merchant-partner-service-descriptions",
  DOCUMENTS_PERFORMANCE_DRS_BASIC_DE:
            "https://www.anybill.de/de/legal-documents/merchant-partner-service-descriptions",
  DOCUMENTS_PARTNER_TERMS_MERCHANT_EN:
            "https://files.anybill.de/legal-documents-public/kmu-smb/anybill_02_partner-terms-merchant-partner-smb-en_final.pdf",
  DOCUMENTS_PARTNER_TERMS_MERCHANT_DE:
            "https://files.anybill.de/legal-documents-public/kmu-smb/anybill_02_partnerbedingungen-haendlerpartner-kmu_de_final.pdf",
  DOCUMENTS_FEE_SCHEDULE_EN:
            "https://files.anybill.de/legal-documents-public/kmu-smb/anybill_05_fee-schedule-smb_en_final.pdf",
  DOCUMENTS_FEE_SCHEDULE_DE:
            "https://files.anybill.de/legal-documents-public/kmu-smb/anybill_05_gebuehrenordnung-kmu_de_final.pdf",
  DOCUMENTS_DATA_PRIVACY_EN: "https://partner.anybill.de/en/privacy",
  DOCUMENTS_DATA_PRIVACY_DE: "https://partner.anybill.de/privacy",
  DOCUMENTS_GLOSSARY_EN:
            "https://files.anybill.de/legal-documents-public/kmu-smb/anybill_05_glossary-smb_en_final.pdf",
  DOCUMENTS_GLOSSARY_DE:
            "https://files.anybill.de/legal-documents-public/kmu-smb/anybill_05_glossar-kmu_de_final.pdf",

  // -- Content Management --
  CONTENT_MANAGEMENT_HELPDESK:
            "https://anybill.freshdesk.com/support/solutions/articles/80001025587-content-management-optionales-add-on-",

  // - Customer Management -
  CUSTOMER_MANAGEMENT_ONBOARDING_HELP: "https://anybill.freshdesk.com/support/solutions/folders/80000695094",
};
